import { render, staticRenderFns } from "./DefiFMintClaimRewardsConfirmation.vue?vue&type=template&id=fb0eff52&"
import script from "./DefiFMintClaimRewardsConfirmation.vue?vue&type=script&lang=js&"
export * from "./DefiFMintClaimRewardsConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports